export default __webpack_public_path__ + "static/media/open-account-login.c4826e35.svg";